var IMAGE_HOVER_ANIMATIONS = {
    NO_EFFECT: 'NO_EFFECT',
    ZOOM_IN: 'ZOOM_IN',
    BLUR: 'BLUR',
    GRAYSCALE: 'GRAYSCALE',
    SHRINK: 'SHRINK',
    INVERT: 'INVERT',
    COLOR_IN: 'COLOR_IN',
    DARKENED: 'DARKENED',
    MAIN_COLOR: 'MAIN_COLOR',
};
export default IMAGE_HOVER_ANIMATIONS;
//# sourceMappingURL=imageHoverAnimations.js.map